import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { authUtils } from "@/utils/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MENTORS = [
  { key: "lister", label: "Lister · Ableton / FL Studio Course" },
  { key: "alex_m", label: "Alex M · 8-Week Ableton Course" },
];

export default function CourseSpotsManager() {
  const [spots, setSpots] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/course-spots`).then((r) => setSpots(r.data)).catch(() => setSpots({ lister: 0, alex_m: 0 }));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { lister: Number(spots.lister), alex_m: Number(spots.alex_m) };
      const r = await axios.put(`${API}/admin/course-spots`, payload, authUtils.getAuthConfig());
      setSpots(r.data);
      toast.success("Course spots updated");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to update spots");
    } finally {
      setSaving(false);
    }
  };

  if (!spots) return null;
  return (
    <div className="glass rounded-2xl p-6 mb-6" data-testid="course-spots-manager">
      <h2 className="font-heading text-xl font-bold text-white mb-1">Production Course Spots</h2>
      <p className="text-white/50 text-sm mb-5">Shown as a "spots available this month" sticker on the Lessons page. Set 0 to show fully booked.</p>
      <div className="grid sm:grid-cols-2 gap-4 mb-5">
        {MENTORS.map((m) => (
          <label key={m.key} className="block">
            <span className="text-white/70 text-sm">{m.label}</span>
            <Input
              type="number"
              min={0}
              max={50}
              value={spots[m.key]}
              onChange={(e) => setSpots({ ...spots, [m.key]: e.target.value })}
              className="mt-1 bg-dream-surface border-dream-border text-white"
              data-testid={`course-spots-input-${m.key}`}
            />
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={saving} className="bg-dream-violet hover:bg-dream-violet-glow text-white rounded-full" data-testid="course-spots-save-btn">
        {saving ? "Saving..." : "Save Spots"}
      </Button>
    </div>
  );
}
